module.exports = __webpack_public_path__ + "img/event-1.978c32a3.jpg";